import { useEffect } from 'react';

import { UseOnClickOutside } from './interfaces';

export const useOnClickOutside: UseOnClickOutside = (
  ref,
  handler,
  ignoreParentClassnames = false
) => {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent): void => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current) handler();
      if (ref.current?.contains(event.target as HTMLElement)) {
        return;
      }
      handler();
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, ignoreParentClassnames]);
};
